<template>
  <v-container fluid fill-height class="loginOverlay ma-auto">
    <v-layout flex align-center justify-center>
      <v-flex xs12 sm5 md3>
        <LoginForm :portalName="$t('customer.portal.title')"  :loginFunction="loginFunc" />
      </v-flex>
    </v-layout>
  </v-container>
</template>


<script>
import LoginForm from "@/components/Forms/LoginForm.vue";

export default {
  name: "LoginPage",
  components: {
    LoginForm,
  },

  data() {
    return {

    };
  },

  mounted() { },

  methods: {
    loginFunc({ username, password }) {
      return this.$store.dispatch("customerLogin", { username: username, password });
    }
  },

  computed: {},

  watch: {},
};
</script>


<style lang="scss"></style>